import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInstanceInfo as GetInstanceInfoQuery,
    InstanceInfo as InstanceInfoFragment,
} from 'nutshell-graphql-types';

import GET_INSTANCE_INFO from './graphql/queries/get-instance-info.graphql';

export const useGetInstanceInfo = (): {
    sessionInstance: InstanceInfoFragment | null | undefined;
    errorMessage: string | null | undefined;
    isLoading: boolean;
    refetch: () => Promise<any>;
} => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetInstanceInfoQuery, Record<any, any>>(GET_INSTANCE_INFO, {
        fetchPolicy: 'cache-and-network',
    });

    const sessionInstance = data ? data.sessionInstance : null;

    return {
        isLoading,
        sessionInstance,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
